import axios from "axios";
import api from "@/plugins/api";
/** Fetches the current user's pinned list preferences. Returns null when none recorded (BFF 404). */
export async function getListViews(entity) {
    try {
        const response = await api.get("/list-views", {
            params: { entity },
            unwrapEnvelope: true,
        });
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
/** Persists the current user's pinned list preferences. */
export async function saveListViews(prefs) {
    await api.put("/list-views", prefs, { unwrapEnvelope: true });
}
